module.exports = __webpack_public_path__ + "img/ico-unyz.828a4a73.png";